import { useState, useEffect } from 'react';

/**
 * Hook pour debouncer une valeur
 * Autorisé par CONTEXT.md car c'est un effet pur avec cleanup
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cleanup systématique (respecte CONTEXT.md)
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
